import api from './api';
import {
  DataTransfer,
  CreateTransferRequest,
  UpdateTransferStatusRequest,
} from '../types/transfer.types';

export const TransferService = {
  getAllTransfers: async (): Promise<DataTransfer[]> => {
    const response = await api.get<DataTransfer[]>('/data-transfers');
    return response.data;
  },

  getSentTransfers: async (): Promise<DataTransfer[]> => {
    const response = await api.get<DataTransfer[]>('/data-transfers/sent');
    return response.data;
  },

  getReceivedTransfers: async (): Promise<DataTransfer[]> => {
    const response = await api.get<DataTransfer[]>('/data-transfers/received');
    return response.data;
  },

  getTransferById: async (id: string): Promise<DataTransfer> => {
    const response = await api.get<DataTransfer>(`/data-transfers/${id}`);
    return response.data;
  },

  createTransfer: async (transferData: CreateTransferRequest): Promise<DataTransfer> => {
    const response = await api.post<DataTransfer>('/data-transfers', transferData);
    return response.data;
  },

  updateTransferStatus: async (id: string, statusData: UpdateTransferStatusRequest): Promise<DataTransfer> => {
    const response = await api.put<DataTransfer>(`/data-transfers/${id}/status`, statusData);
    return response.data;
  },
};